import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import type { TitleOfferFragment, FastOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { MonetizationType, type PromotedBundleEdge } from '@/@types/graphql-types';

import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { OfferPresentationType } from '@/interfaces/titles';
import { useExperiment } from '@/libraries/experiment';
import { storeToRefs } from 'pinia';

type BuyboxRowOffer = (TitleOfferFragment | FastOfferFragment) & {
	iconUrl?: string;
	icons?: string[];
	bundleId?: number;
	bundleTechnicalName?: string;
};

interface BuyBoxRowProps {
	title: TitleDetail;
	promoted?: boolean;
	inline?: boolean;
	hideCategoryLabel?: boolean;
	additionalContexts?: SnowplowContext[];
	offers?: BuyboxRowOffer[];
	bundles?: PromotedBundleEdge[];
	isBannerBuyBox?: boolean;
	// START AVOD
	isAVODActive?: boolean;
	// END AVOD
	episodeBuyBoxPresentationType?: OfferPresentationType | null;
	isEpisodeBuybox?: boolean;
	activePresentationType?: OfferPresentationType | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GridOfferRowRedesignExp',
  props: {
    title: null,
    promoted: { type: Boolean },
    inline: { type: Boolean },
    hideCategoryLabel: { type: Boolean },
    additionalContexts: { default: () => [] },
    offers: { default: () => [] },
    bundles: { default: () => [] },
    isBannerBuyBox: { type: Boolean },
    isAVODActive: { type: Boolean },
    episodeBuyBoxPresentationType: null,
    isEpisodeBuybox: { type: Boolean },
    activePresentationType: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, promoted?: boolean, inline?: boolean, hideCategoryLabel?: boolean, additionalContexts: SnowplowContext[], offers: BuyboxRowOffer[], bundles: PromotedBundleEdge[], isBannerBuyBox?: boolean, isAVODActive?: boolean, episodeBuyBoxPresentationType?: OfferPresentationType | null, isEpisodeBuybox?: boolean, activePresentationType?: OfferPresentationType | null };

const GridOfferRedesignExp = () =>
	import('@/components/experiments/GridBuyboxRedesignExps/components/GridOfferRedesignExp.vue');
const GridBundleRedesignExp = () =>
	import('@/components/experiments/GridBuyboxRedesignExps/components/GridBundleRedesignExp.vue');
const GridOfferMoreInfoExp = () =>
	import('@/components/experiments/GridBuyboxRedesignExps/components/GridOfferMoreInfoExp.vue');



const { isTTBLanguage } = storeToRefs(useLanguageStore());

const { activeVariantWithControlGroup: gridRedesignCTAExpVariant } = useExperiment('EXP_GRID_REDESIGN_CLICK');

const { activeVariantWithControlGroup: gridMoreInfoVariant } = useExperiment('EXP_GRID_REDESIGN_MORE_INFO');

const bundleOffers = computed(() => {
	const iconkey =
		['variant_1', 'variant_3'].includes(gridRedesignCTAExpVariant.value || '') ||
		['variant_1', 'variant_2'].includes(gridMoreInfoVariant.value || '')
			? 'iconWide'
			: 'icon';
	return props.bundles.map(bundle => {
		return {
			...bundle.offer,
			standardWebURL: bundle.promotionUrl,
			bundleId: bundle.node.bundleId,
			bundleTechnicalName: bundle.node.technicalName,
			icons: bundle.node.packages.map(pkg => pkg[iconkey]),
		};
	});
});

// START AVOD
const rowOffers = computed(() => {
	// Only show One Plex offer at a time.
	// + Always filtering out Justwatch-plex Provider as it's only used by partners.
	const AVODTechnicalName = props.isAVODActive
		? ['plex', 'justwatchplexchannel']
		: ['plexplayer', 'justwatchplexchannel'];

	// HIDE OTT Studio Channel from regular free offers when Player offer is present
	if (props.offers.some(offer => offer.package.technicalName === 'ottstudioplayer')) {
		AVODTechnicalName.push('ottstudiochannel');
	}
	const offers = [...props.offers.filter(el => !AVODTechnicalName.includes(el.package.technicalName))];

	// JUSTWATCH_TV
	const indexOfJustWatchTvOffer = offers.findIndex(offer => offer.package.technicalName === 'justwatchtv');
	const indexOfFirstFreeOffer = offers.findIndex(offer =>
		[MonetizationType.Ads, MonetizationType.Free].includes(offer.monetizationType)
	);
	if (indexOfJustWatchTvOffer > indexOfFirstFreeOffer) {
		const justWatchTVhOffer = offers.splice(indexOfJustWatchTvOffer, 1)[0];
		offers.splice(indexOfFirstFreeOffer, 0, justWatchTVhOffer);
	}
	// JUSTWATCH_TV

	return offers;
});
// END AVOD

const allOffers = computed(() => {
	const offers = rowOffers.value.map(offer => ({ type: 'offer', data: offer }));
	const bundles = bundleOffers.value.map(bundle => ({ type: 'bundle', data: bundle }));
	return [...offers, ...bundles];
});

return { __sfc: true,GridOfferRedesignExp, GridBundleRedesignExp, GridOfferMoreInfoExp, props, isTTBLanguage, gridRedesignCTAExpVariant, gridMoreInfoVariant, bundleOffers, rowOffers, allOffers }
}

})